import { createElement } from 'react';
import { strokePoints } from '../../store/illustrations.js';
import { drawingBox, CAPTURE_TAGS, CAPTURE_ATTRIBUTES, CAPTURE_STYLES } from '../../store/slideCapture.js';

export function CapturedNode({ node, styles, paper = false }) {
  if(typeof node==='string')return node;
  if(!node || !CAPTURE_TAGS.has(node.t))return null;
  const style = Object.fromEntries(Object.entries(styles?.[node.s] || {}).filter(([key]) => CAPTURE_STYLES.has(key)));
  if (paper && style.backgroundColor) style.backgroundColor = '#fff';
  const props={style};
  const names={'stroke-width':'strokeWidth','stroke-linecap':'strokeLinecap','stroke-linejoin':'strokeLinejoin','text-anchor':'textAnchor',colspan:'colSpan',rowspan:'rowSpan'};
  for(const [k,v] of Object.entries(node.a||{}))if(CAPTURE_ATTRIBUTES.has(k))props[names[k]||k]=v;
  return createElement(node.t,props,(node.c||[]).map((child,i)=><CapturedNode key={i} node={child} styles={styles} paper={paper}/>));
}
export default function SavedSlide({capture,strokes=[],label='Saved slide with advisor annotations', align='xMidYMid meet', paper=false, fill=null}) {
  if(!capture)return null;
  const box=drawingBox(capture,strokes);
  return <svg className="conv-saved-slide" viewBox={`${box.x} ${box.y} ${box.width} ${box.height}`} preserveAspectRatio={align} role="img" aria-label={label}>
    <rect x={box.x} y={box.y} width={box.width} height={box.height} fill={fill || (paper?"#fff":"#f5f9fc")}/>
    <foreignObject x="0" y="0" width={capture.width} height={capture.height}>
      <div xmlns="http://www.w3.org/1999/xhtml" className="conv-captured-root" style={{width:capture.width,height:capture.height}}><CapturedNode node={capture.tree} styles={capture.styles} paper={paper}/></div>
    </foreignObject>
    {strokes.map((s,i)=><polyline key={i} points={strokePoints(s,capture.width)} fill="none" stroke={s.c} strokeWidth={s.w||3} strokeLinecap="round" strokeLinejoin="round"/>)}
  </svg>;
}
